export default {
  HOME: 'home',
  BLANK: 'blank',
  COMPATIBILITY_TEST: 'compatibility.test',
  CONTACT: 'contact',
  DETAIL_SECTION: 'detail.of.section',
  DIAGNOSTIC: 'diagnostic',
  FAQ: 'faq',
  INDEX: 'index',
  KIDS_HOME: 'kids.home',
  SEARCH: 'search',
  STATIC_PAGE: 'static.page',
  SUBSCRIBER_LOGIN: 'subscriber.login',
  SUBSCRIBER_AGREEMENTS: 'subscriber.agreements',
  SUBSCRIBER_PASSWORD_REQUEST: 'subscriber.password.request',
  SUBSCRIBER_PASSWORD_RESET: 'subscriber.password.reset',
  SUBSCRIBER_SUSPENDED: 'subscriber.suspended',
  SUBSCRIBER_REGISTER: 'subscriber.register',
  SUBSCRIBER_MAIL_VERIFY: 'subscriber.mail.verify',
  SUBSCRIBER_PHONE_VERIFY: 'subscriber.phone.verify',
  SUBSCRIBER_USER_SETUP: 'subscriber.user.setup',
  SUBSCRIBER_MY_LIST: 'subscriber.my.list',
  SUBSCRIBER_MY_LIST_PAGE: 'subscriber.my.list.page',
  SUBSCRIBER_MY_ACCOUNT: 'subscriber.my.account',
  DETAIL: 'detail',
  DETAIL_WITH_ARTICLE: 'detail.with.article',
  CATALOG: 'catalog',
  CATALOG_WITH_CATEGORY: 'catalog.with.category',
  NOT_FOUND: 'not-found',
  ERROR: 'error',
};
